<template>
  <div class="overview col-md-12">
    <ed-card class="overview-card" footer-button="false">
      <div v-if='!hasData' slot="body" class="soft-text loading-text">
        <span />Loading summary ...
      </div>
      <div v-if='hasData' slot="body" style="margin-top: -20px !important;" class="soft-text">

        <div class="col-md-3">
          <div>Most Recent Payment</div>
          <div>
            <strong>{{ headerData.MostRecentPaymentDate }} - {{ headerData.MostRecentPayAmount }}</strong>
          </div>
        </div>

        <div class="col-md-3">
          <div>Next Payment Due</div>
          <div>
            <strong>{{ headerData.NextPayDue }}</strong>
          </div>
        </div>

        <div class="col-md-3">
          <div>Open Invoices</div>
          <div>
            <strong>{{ headerData.OpenInvoices }} invoices - {{ headerData.OpenInvoicesAmount }}</strong>
          </div>
        </div>

        <div class="col-md-3">
          <div>Overdue Invoices</div>
          <div>
            <strong>{{ headerData.OverdueInvoices }} invoices - {{ headerData.OverdueInvoicesAmount }}</strong>
          </div>
        </div>
      </div>
    </ed-card>
  </div>
</template>

<script>

export default {
  data() {
    return {
      hasData: false,
      headerData: []
    }
  },
  created() {
    this.api.get(this.api.$.invoice.skybox).then(r => {
      if (r.data) {
        this.headerData = r.data
        this.hasData = true
      }
    })
  }
}

</script>

<style scoped lang='scss'>
.overview {
  .overview-card {
    margin-top: 3px;
    margin-bottom: 15px;
    width: 100%;
    height: 80px;
    min-height: 0;
    border-radius: 3px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
    padding: 20px 16px 14px
  }
}

.soft-text {
  transform: rotate(.03deg); // soften font a bit
}

.loading-text{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/Invoices/data-skybox.vue